import { CardActionArea, CardHeader, Grid, makeStyles, CardContent, FormControlLabel, Button, Hidden, FormControl, InputLabel, CircularProgress, Backdrop } from "@material-ui/core";
import clsx from 'clsx';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';

import braintree from 'braintree-web'

import { getCardIcon } from 'util/creditCard';
import { useTrackEvent } from 'util/trackEvent';
import { createNewCCPaymentMethod, getBraintreeClientToken } from 'services/payments.service';
import { toast } from "react-hot-toast";

import Cards from 'react-credit-cards';
import "react-credit-cards/es/styles-compiled.css";
import { Alert } from "@material-ui/lab";
import ReactJson from "react-json-view";
import { Add } from "@material-ui/icons";
import { toasterror } from "util/toasterror";


const useStyles = makeStyles(theme => ({
  paymentDisabled: {
    color: theme.palette.text.disabled,
  },
  padded: {
    marginRight: theme.spacing(2),
  },
  input: {
    marginBottom: theme.spacing(1),
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    '& > *': {
      marginLeft: theme.spacing(2),
    }
  },
  cardIcon: {
    width: '3rem',
    height: '3rem',
    borderRadius: 3,
  },
  fakeInputField: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    padding: "1rem",

    maxHeight: "3rem",

  },
  fieldGroup: {
    display: "grid",
    marginBottom: "1rem",
  },
  formFields: {
    padding: '1rem',
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

const CreateBraintreeDropin = ({
  onSuccess = () => { }
}) => {
  const classes = useStyles()

  const [displayCreate, setDisplayCreate] = useState(true);
  const trackEvent = useTrackEvent()

  const [clientInstance, setClientInstance] = useState(null);
  
  const [error, setError] = useState(null);
  const [cardError, setCardError] = useState(true);
  const [braintreeLoading, setBraintreeLoading] = useState(false);
  
  const dropinRef = useRef(null)
  const handleCallback = useCallback(
    ({ issuer }, isValid) => {

    },
    [],
  );

  const handleSubmit = useCallback(
    async (payload) => {
      try {
        setBraintreeLoading(true)
        const nonce = payload?.nonce
        const isPaypal = payload?.type === 'PayPalAccount'
        const newPaymentParams = {
          label: isPaypal ? 'Paypal' : 'Personal',
          is_default: 0,
          nonce: nonce,
          gateway_type: 'BRAINTREE',
          is_paypal: isPaypal,
        }
        const results = await createNewCCPaymentMethod(newPaymentParams)
        setDisplayCreate(true)
        clientInstance?.teardown()
        onSuccess()
      } catch (error) {
        setError(error?.message?.en || error?.response?.data?.message?.en || error?.response?.data?.details || error.message)
      } finally {
        setBraintreeLoading(false)
      }


    }, [clientInstance]
  );
  const createDropin = useCallback(
    async () => {
      try {
        const clientToken = await getBraintreeClientToken()
        const isDropinReady = dropinRef?.current
        const bt = braintree.setup(
          clientToken,
          'dropin', 
          {
            container: 'dropin-container',
            form: 'checkoutForm',
            cardholderName:{
              required: true
            },
            paypal:{
              container: 'paypal-container',
            },
            onReady: function (integration) {
              setClientInstance(integration)
            },
            onPaymentMethodReceived: function (payload) {
              setCardError(false)
              handleSubmit(payload)
            },
            onError: function (error) {
              setCardError(true)
              setError(error?.message)
            }
          }
        )
        
        // BTDropin.create({
        //   authorization: clientToken,
        //   container: '#dropin-container',
        //   card: {
        //     cardholderName: {
        //       required: true
        //     },
        //   },
        //   paypal: {
        //     flow: 'vault'
        //   }
        // }, (error, dropinInstance) => {
        //   if (error) {
        //     setCardError(true)
        //     setError(error?.message?.en || error?.response?.data?.message?.en || error?.response?.data?.details || error?.message)
        //     return
        //   }
        //   dropinInstance.on('paymentMethodRequestable', (event) => {
        //     setCardError(false)
        //   })
        //   setClientInstance(dropinInstance)
        // });
        console.log('CreateBraintreeDropin.jsx (137)', bt)
      } catch (error) {
        // toasterror(error?.message?.en || error?.response?.data?.message?.en || error?.response?.data?.details || error?.message)
        setError(error?.message?.en || error?.response?.data?.message?.en || error?.response?.data?.details || error?.message)
      }
    }, [dropinRef]
  );



  useEffect(
    () => {
      const run = async () => {
        setBraintreeLoading(true)
        if (!displayCreate) {
          await createDropin()
        }
        setBraintreeLoading(false)
      }
      if (!displayCreate) {
        run()
      }
    }, [displayCreate]
  );

  if (displayCreate) {
    return (
      <Grid container className={clsx(classes.padded, classes.root)}>
        <Grid item xs={12} md={6}>
          <CardActionArea onClick={() => {
            trackEvent('Payment - click Add Debit/Credit', {})
            setDisplayCreate(false)
          }}>
            <CardHeader avatar={
              <img className={classes.cardIcon} src={getCardIcon('card')} alt='credit/debit' />
            } title="Add Debit/Credit" />
          </CardActionArea>
        </Grid>
        <Grid item xs={12} md={6}>
          {/* <CardActionArea disabled>
              <CardHeader className={classes.paymentDisabled} avatar={
                <img className={classes.cardIcon} src={getCardIcon('paypal')} alt={'paypal'} />
              } title="Login to paypal" />
            </CardActionArea> */}
        </Grid>
      </Grid>
    )
  }

  return (
    <>
      <Backdrop className={classes.backdrop} open={braintreeLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <CardHeader title="Add a new card" />
      <CardContent>
        <Grid container>
          <Grid item xs={12} md={12}>
            <div id="dropin-container" ref={dropinRef}></div>
          </Grid>
          <Grid item xs={12} md={12}>
            <div id="paypal-container"></div>
            <input type="hidden" name="payment_method_nonce" />
          </Grid>
          <Grid item xs={12} md={12}>
            {error && <Alert severity="error">{error}</Alert>}
            <div className={classes.actions}>
              <form id="checkoutForm">
              <Button onClick={() => {
                trackEvent('Payment - Create Card - click Cancel', {})
                setDisplayCreate(true)
              }}
                variant="outlined">Cancel
              </Button>
              {/* <Button
                disabled={cardError}
                onClick={() => {
                  trackEvent('Payment - Create Card - click Add Card', {})
                  handleSubmit()
                }} variant="contained" color="primary">Add Card</Button> */}
                <Button type="submit"
                  form="checkoutForm"
                  // disabled={cardError}
                >
                  Add Card
                </Button>
              </form>
            </div>
          </Grid>
        </Grid>
      </CardContent>

    </>
  )
}

export { CreateBraintreeDropin }